import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bae8f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-72" }
const _hoisted_2 = { class: "font-bold text-2xl pb-1 text-center" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "table-auto w-full md:max-w-xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-blue-600" }, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Lag"),
    /*#__PURE__*/_createElementVNode("th", null, "M"),
    /*#__PURE__*/_createElementVNode("th", null, "V"),
    /*#__PURE__*/_createElementVNode("th", null, "O"),
    /*#__PURE__*/_createElementVNode("th", null, "F"),
    /*#__PURE__*/_createElementVNode("th", null, "Matcher"),
    /*#__PURE__*/_createElementVNode("th", null, "Set"),
    /*#__PURE__*/_createElementVNode("th", null, "Bollar"),
    /*#__PURE__*/_createElementVNode("th", null, "Poäng")
  ])
], -1))

import { ITeam } from '../interfaces'
import TeamRow from './TeamRow.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    teams: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.teams, (t) => {
            return (_openBlock(), _createBlock(TeamRow, {
              key: t.team,
              team: t
            }, null, 8, ["team"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})